import Dashboard from "../pages/dashboard/Dashboard";
import Notifications from "../pages/notifications/Notifications";

function DashboardRoutes() {
    return [
        {
            path: "/dashboard",
            element: <Dashboard />
        },
        {
            path: "/notifications",
            element: <Notifications />
        }
    ];
}

export default DashboardRoutes;
